import { useEffect } from "react";
import { lockBodyScroll } from "@/utils/bodyScrollLock";

/**
 * Locks document scroll while `active` is true.
 * Nested overlays each call this hook; ref-counting keeps the lock until all close.
 */
export default function useBodyScrollLock(active) {
  useEffect(() => {
    if (!active) return undefined;
    return lockBodyScroll();
  }, [active]);
}
